import { render } from "./ColorModeModal.vue?vue&type=template&id=76573987&scoped=true"
import script from "./ColorModeModal.vue?vue&type=script&lang=js"
export * from "./ColorModeModal.vue?vue&type=script&lang=js"

import "./ColorModeModal.vue?vue&type=style&index=0&id=76573987&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76573987"]])

export default __exports__